<template>
<div>
    <span v-if="!items || !items.length">No items available</span>
    <v-chip @click="toggleSelection(item)" class="mr-1 mb-1" v-for="(item,i) in items" :color="color(item)" :text-color="textColor(item)" :key="i">
        <v-avatar>
            <v-icon v-if="item._selected" color="blue darken-1">check_circle</v-icon>
            <v-icon v-else color="grey">account_circle</v-icon>
        </v-avatar>
        {{bestName(item)}}</v-chip>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        items: Array,
    },

    computed: {

    },

    methods: {
        bestName(item) {
            return item.text || item.label || item.title || item.name || '[item]'
        },
        color(item) {
            if(item._selected)
                return 'blue lighten-2'
            return 'grey lighten-1'
        },

        textColor(item) {
            return 'white'
        },
        toggleSelection(item) {
            this.$set(item, '_selected', !item._selected)
        }
    },

    created() {

    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// ChipSelector.vue?c7a704ac